import { useCallback } from "react";
import { useRecoilState } from "recoil";

import { TranslateState } from "global-states";
import { LANGUAGES } from "constants/languages";
import GlobalInstanceManager from "instance-manger";

export const useTranslation = () => {
  const [translate, setTranslate] = useRecoilState(TranslateState);
  const webComponentConfig = GlobalInstanceManager.webcomponentProps;

  const init = useCallback(async (lang?: string) => {
    if (!translate.data) {
      const loadTranslations = async () => {
        try {
          const translations = LANGUAGES[lang as "en"];
          if (translations) setTranslate({ ...translate, data: translations });
        } catch (err) {
          /* eslint-disable no-console */
          console.error(
            `Could not load translations for locale: ${translate.lang} ${err}`
          );
        }
      };

      if (webComponentConfig.lang) {
        await loadTranslations();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const t = (path: string) => {
    const keys = path.split(".");
    let result: any = translate?.data ?? {};

    for (const key of keys) {
      result = result[key];
      if (!result) {
        return "";
      }
    }

    return result;
  };

  return { t, init };
};
